// eslint-disable-next-line no-restricted-imports
import { styled, TableRow } from '@mui/material';
import { ReactNode } from 'react';

export type RowProps = {
  children: ReactNode;
};

const StyledRow = styled(TableRow)({
  borderBottom: '1px solid var(--stroke-stroke-primary-color)',
});

export const Row = ({ children }: RowProps) => {
  return <StyledRow>{children}</StyledRow>;
};
